/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const MenuMyLeadsIcon = ({
  className,
  style: styleFromProps,
  onClick,
  size,
  color = '#6190B7',
  colorSecondary = '#C9DCEB',
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18402_20411)">
        <path
          d="M13.5 15.75H0V9C0 7.75737 1.00737 6.75 2.25 6.75H11.25C12.4926 6.75 13.5 7.75737 13.5 9V15.75Z"
          fill={color}
        />
        <path
          d="M6.75 6.75C8.61396 6.75 10.125 5.23896 10.125 3.375C10.125 1.51104 8.61396 0 6.75 0C4.88604 0 3.375 1.51104 3.375 3.375C3.375 5.23896 4.88604 6.75 6.75 6.75Z"
          fill={color}
        />
        <path
          d="M24.75 7.2002V9.9002H18L16.875 8.5502L18 7.2002H24.75Z"
          fill={color}
        />
        <path
          d="M29.25 12.1504V14.8504H18L16.875 13.5004L18 12.1504H29.25Z"
          fill={color}
        />
        <path
          d="M13.5 36H0V29.25C0 28.0074 1.00737 27 2.25 27H11.25C12.4926 27 13.5 28.0074 13.5 29.25V36Z"
          fill={colorSecondary}
        />
        <path
          d="M6.75 27C8.61396 27 10.125 25.489 10.125 23.625C10.125 21.761 8.61396 20.25 6.75 20.25C4.88604 20.25 3.375 21.761 3.375 23.625C3.375 25.489 4.88604 27 6.75 27Z"
          fill={colorSecondary}
        />
        <path
          d="M31.5 32.4004V35.1004H18L16.875 33.7504L18 32.4004H31.5Z"
          fill={colorSecondary}
        />
        <path
          d="M36 27.4502V30.1502H18L16.875 28.8002L18 27.4502H36Z"
          fill={colorSecondary}
        />
        <path d="M16.6504 7.2002H18.9004V9.9002H16.6504V7.2002Z" fill={color} />
        <path
          d="M16.6504 12.1504H18.9004V14.8504H16.6504V12.1504Z"
          fill={color}
        />
        <path
          d="M16.6504 32.4004H18.9004V35.1004H16.6504V32.4004Z"
          fill={color}
        />
        <path
          d="M16.6504 27.4502H18.9004V30.1502H16.6504V27.4502Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_18402_20411">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
